class e extends HTMLElement {
  constructor() {
    super(),
      (this.videoElement = null),
      (this.playButton = null),
      (this.isPlaying = !1);
  }
  connectedCallback() {
    if (
      ((this.videoElement = this.querySelector(".video-player__video")),
      (this.playButton = this.querySelector('[js-video-player="play-pause"]')),
      !this.videoElement || !this.playButton)
    ) {
      console.error("VideoPlayer: Missing required elements");
      return;
    }
    this.setupAccessibility(), this.attachEventHandlers();
  }
  setupAccessibility() {
    !this.videoElement ||
      !this.playButton ||
      (this.isPlaying
        ? this.playButton.classList.add("is-playing")
        : this.playButton.classList.remove("is-playing"),
      this.playButton.setAttribute("aria-pressed", String(this.isPlaying)));
  }
  attachEventHandlers() {
    !this.videoElement ||
      !this.playButton ||
      (this.videoElement.addEventListener("play", () =>
        this.handlePlayPause(!0)
      ),
      this.videoElement.addEventListener("pause", () => this.handlePlayPause()),
      this.playButton.addEventListener("click", () => this.togglePlay()),
      this.playButton.addEventListener("keypress", (t) => {
        (t.key === "Enter" || t.key === " ") &&
          (t.preventDefault(), this.togglePlay());
      }));
  }
  handlePlayPause(t = !1) {
    !this.videoElement ||
      !this.playButton ||
      ((this.isPlaying = t),
      this.playButton.setAttribute("aria-pressed", String(t)),
      t
        ? this.playButton.classList.add("is-playing")
        : this.playButton.classList.remove("is-playing"));
  }
  togglePlay() {
    !this.videoElement ||
      !this.playButton ||
      (this.isPlaying ? this.videoElement.pause() : this.videoElement.play());
  }
}
customElements.define("uwp-video-player", e);
